// window.addEventListener("resize", (event) => {
//   if (window.innerWidth >= 1140) {
//     document.querySelector(".Header__MainNav").style.position = "absolute";
//     document.querySelector(".Header__MainNav").style.display = "flex";
//     document.querySelector(".Header__MainNav").style.bottom = "0";
//     document.querySelector(".Header__MainNav").style.left = "0";
//     document.querySelector(".Header__MainNav").style.paddingBottom = "8px";
//     document.querySelector(".Header__MainNav").style.paddingTop = "8px";
//     document.querySelector(".Header__MainNav").style.textAlign = "center";
//     document.querySelector(".Header__MainNav").style.width = "100%";
//     document.querySelector(".Header__MainNav").style.justifyContent = "center";
//     // document.querySelector(".Header__MainNav").style.boxShadow =
//     //   "0px 0px 2px 0px #222";
//     document.querySelector(".Header__MainNav").style.marginRight = "45px";
//     // document.querySelector("#shopify-section-header").style.height = "112.5px";
//   } else {
//     document.querySelector("#shopify-section-header").style.height = "auto";
//     document.querySelector(".Header__MainNav").style.display = "none";
//   }
// });

// document.querySelectorAll(".ColorSwatch__Radio").forEach((input) => {
//   input.addEventListener("click", () => {
//     document.querySelector(".Product__Gallery").scrollIntoView({
//       behavior: "smooth",
//     });
//   });
// });

window.addEventListener("option:changed", (e) => {
  if (e.detail.name.includes("Stone_")) {
    document.querySelector(".Product__Gallery").scrollIntoView({
      behavior: "smooth",
    });
  }
});

function handleColorRestrictions(metalOptionPicker) {
  const metalType = metalOptionPicker.value;
  const selectedChain = document.querySelector(".chain-selector.selected");

  if (selectedChain) {
    if (
      (!selectedChain || selectedChain.dataset.chain !== "standard") &&
      (metalType === "14k Gold" || metalType === "18k Gold")
    ) {
      document
        .querySelectorAll(".ColorSwatchList > .HorizontalList__Item")
        .forEach((li) => {
          const [input, label] = li.children;
          if (input.dataset.value === "Yellow") {
            label.click();
          } else {
            input.disabled = true;
            label.style.opacity = "0.7";
          }
        });
    } else {
      colorSwatches.forEach((swatch) => {
        swatch.disabled = false;
        const label = swatch.nextElementSibling;
        label.style.opacity = "1";
      });
    }
  }
}
// Cart get it by date js code

// Resilient cart delivery date logic: expose a function and re-run when cart drawer/snippet is re-rendered
(function () {
  const DELIVERY_DAYS = 12;

  function addBusinessDays(date, days) {
    const result = new Date(date);
    while (days > 0) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        days--;
      }
    }
    return result;
  }

  function formatEstimatedDate(dateObj) {
    // Source: cart drawer snippet -> window.translations
    const months = window.translations.months;
    const daysShort = window.translations.days;

    return `${daysShort[dateObj.getDay()]}, ${months[dateObj.getMonth()]} ${dateObj.getDate()}`;
  }

  function setCartDeliveryDate() {
    try {
      const el = document.getElementById("cart-deliverydate");
      if (!el) return false;
      const now = new Date();
      const estimated = addBusinessDays(now, DELIVERY_DAYS);
      el.textContent = formatEstimatedDate(estimated);
      // el.textContent = "Christmas";
      return true;
    } catch (e) {
      // swallow errors to avoid breaking other scripts
      console.error("setCartDeliveryDate error", e);
      return false;
    }
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setCartDeliveryDate);
  } else {
    setCartDeliveryDate();
  }

  // Debounce helper
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  const debouncedSetter = debounce(setCartDeliveryDate, 100);

  // Observe changes to the cart drawer container and re-run when innerHTML changes
  const cartDrawerSelector = "#sidebar-cart";
  const observeTarget = document.body;

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // look for added/changed nodes that contain our cart drawer or the target element
      if (m.addedNodes && m.addedNodes.length) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches && node.matches(cartDrawerSelector)) {
            debouncedSetter();
            return;
          }
          if (node.querySelector && node.querySelector("#cart-deliverydate")) {
            debouncedSetter();
            return;
          }
        }
      }

      if (m.type === "childList" && m.target instanceof HTMLElement) {
        if (m.target.matches && m.target.matches(cartDrawerSelector)) {
          debouncedSetter();
          return;
        }
        if (
          m.target.querySelector &&
          m.target.querySelector("#cart-deliverydate")
        ) {
          debouncedSetter();
          return;
        }
      }
    }
  });

  mo.observe(observeTarget, { childList: true, subtree: true });

  // Also listen for common cart update events from themes/apps
  // const events = [
  //   "cart:updated",
  //   "cart:refresh",
  //   "ajaxCart.update",
  //   "cart:update",
  //   "cart.changed",
  // ];
  // events.forEach((ev) => document.addEventListener(ev, debouncedSetter));

  // Expose for manual re-run if needed
  window.setCartDeliveryDate = setCartDeliveryDate;
})();

//

(function () {
  if (window.__cartDiscountScriptsInitialized) {
    return;
  }

  window.__cartDiscountScriptsInitialized = true;

  const perfectPairNoticeSelector = "#perfectpair-applying-notice";
  let isApplyingPerfectPair = false;
  let perfectPairCheckTimeout = null;

  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      }),
    );
  }

  function schedulePerfectPairCheck(delay) {
    clearTimeout(perfectPairCheckTimeout);
    perfectPairCheckTimeout = window.setTimeout(function () {
      applyPerfectPairIfEligible();
    }, delay || 0);
  }

  function applyPerfectPairIfEligible() {
    const notice = document.querySelector(perfectPairNoticeSelector);

    if (
      !notice ||
      isApplyingPerfectPair ||
      notice.getAttribute("data-perfectpair-pending") === "true"
    ) {
      return;
    }

    isApplyingPerfectPair = true;
    notice.setAttribute("data-perfectpair-pending", "true");

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ discount: "PERFECTPAIR" }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to apply PERFECTPAIR");
        }

        return response.json();
      })
      .then(function () {
        refreshCartDrawer();
      })
      .catch(function () {
        notice.removeAttribute("data-perfectpair-pending");
        window.location.href =
          "/discount/PERFECTPAIR?redirect=" +
          encodeURIComponent(window.location.pathname + window.location.search);
      })
      .finally(function () {
        isApplyingPerfectPair = false;
      });
  }

  const cartDrawerObserver = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }

      if (
        mutation.target instanceof HTMLElement &&
        !mutation.target.closest("#sidebar-cart") &&
        mutation.target.id !== "sidebar-cart"
      ) {
        continue;
      }

      if (document.querySelector(perfectPairNoticeSelector)) {
        schedulePerfectPairCheck(120);
        return;
      }
    }
  });

  if (document.body) {
    cartDrawerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("click", function (event) {
    const removeDiscountButton = event.target.closest(".remove-discount-btn");

    if (!removeDiscountButton) {
      return;
    }

    event.preventDefault();

    Object.keys(localStorage)
      .filter(function (key) {
        return key.startsWith("shine_discount_");
      })
      .forEach(function (key) {
        localStorage.removeItem(key);
      });

    localStorage.setItem("shine_discount_cleared", "true");

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ discount: "" }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to remove discount");
        }

        return response.json();
      })
      .then(function () {
        refreshCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
      });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      schedulePerfectPairCheck(0);
    });
  } else {
    schedulePerfectPairCheck(0);
  }

  document.addEventListener("product:added", function () {
    schedulePerfectPairCheck(250);
  });

  document.documentElement.addEventListener("cart:refresh", function () {
    schedulePerfectPairCheck(250);
  });
})();

//

document.addEventListener("click", function (e) {
  // Apply discount
  if (e.target && e.target.id === "cart-discount-apply") {
    var input = document.getElementById("cart-discount-input");
    var error = document.getElementById("cartDiscountError");
    var errorCode = document.getElementById("cartDiscountErrorDiscountCode");
    // var errorShipping = document.getElementById("cartDiscountErrorShipping");
    error.classList.add("hidden");
    errorCode.classList.add("hidden");
    // errorShipping.classList.add("hidden");
    var code = input.value.trim();
    if (!code) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Determine whether discount was actually applied.
        var applied = false;

        // If the response contains an HTTP-like status error, treat as not applied
        if (data && data.status && data.status !== 200) {
          applied = false;
        } else if (
          data &&
          Array.isArray(data.discount_codes) &&
          data.discount_codes.length
        ) {
          // Look for the attempted code in returned discount_codes (case-insensitive)
          var found = data.discount_codes.find(function (dc) {
            return (
              dc &&
              dc.code &&
              dc.code.toString().toLowerCase() === code.toLowerCase()
            );
          });
          if (found) {
            applied = !!found.applicable;
          } else {
            // fallback: consider total_discount if code not listed
            applied = !!(data.total_discount && data.total_discount > 0);
          }
        } else {
          // fallback: use total_discount as indicator
          applied = !!(data && data.total_discount && data.total_discount > 0);
        }

        if (!applied) {
          // show invalid code error
          error.classList.remove("hidden");
          errorCode.classList.remove("hidden");
          input.value = "";
          return;
        }

        // success: refresh cart UI
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          }),
        );
        // window.location.reload();
      })
      .catch(function () {
        error.classList.remove("hidden");
        errorCode.classList.remove("hidden");
      });
  }

  // Remove discount
  if (e.target && e.target.classList.contains("cart-discount__remove")) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          }),
        );
        // window.location.reload();
      });
  }
});

// Handle Include Chain checkbox to toggle Necklace Length input
(function () {
  function setupChainCheckboxToggle() {
    // Find the checkbox for "Include Chain" - search for any with_chain variant
    const chainCheckboxContainer = document.querySelector(
      '[data-option^="with_chain"]',
    );
    const chainCheckbox = chainCheckboxContainer
      ? chainCheckboxContainer.querySelector(
          'input[type="checkbox"].cl-po--input',
        )
      : null;
    const necklaceLengthOption = document.querySelector(
      '[data-option="necklace_length"]',
    );
    const necklaceLengthSelect = document.querySelector(
      '[data-option="necklace_length"] select.cl-po--input',
    );

    if (!chainCheckbox || !necklaceLengthOption || !necklaceLengthSelect) {
      return; // Elements not found, exit
    }

    // Function to toggle necklace length visibility and state
    function toggleNecklaceLength() {
      if (chainCheckbox.checked) {
        // Show and enable necklace length
        necklaceLengthOption.style.display = "";
        necklaceLengthSelect.disabled = false;
        necklaceLengthSelect.required = true;
      } else {
        // Hide and disable necklace length
        necklaceLengthOption.style.display = "none";
        necklaceLengthSelect.disabled = true;
        necklaceLengthSelect.required = false;
        // Reset selection to default
        necklaceLengthSelect.value = "";
      }
    }

    // Set initial state based on checkbox
    toggleNecklaceLength();

    // Add event listener for checkbox changes
    chainCheckbox.addEventListener("change", toggleNecklaceLength);
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupChainCheckboxToggle);
  } else {
    setupChainCheckboxToggle();
  }

  // Also run when variant changes or product options are re-rendered
  document.addEventListener("variant:changed", setupChainCheckboxToggle);

  // MutationObserver to handle dynamic content loading (for apps that render asynchronously)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        setupChainCheckboxToggle();
      }
    });
  });

  // Observe any shopify app block container for Live Product Options
  const appBlockContainer = document.querySelector(
    ".shopify-app-block [data-live-options]",
  );
  if (appBlockContainer) {
    observer.observe(appBlockContainer.closest(".shopify-app-block"), {
      childList: true,
      subtree: true,
    });
  } else {
    // Fallback: observe the entire product form area
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      observer.observe(productForm, { childList: true, subtree: true });
    }
  }
})();

// /* Fix: Synchronize Product Variants and UI */
// function syncStonesUI() {
//   const stonesSelect = document.getElementById("product-select-stones");
//   console.log("synced in it 1");
//   console.log("synced in it 2", stonesSelect);
//   if (stonesSelect) {
//     stonesSelect.dispatchEvent(new Event("change", { bubbles: true }));
//   }
// }

// // Run on initial load
// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", syncStonesUI);
// } else {
//   syncStonesUI();
// }

// function triggerSync() {
//   syncStonesUI();
//   // Short fallbacks in case external scripts execute asynchronously
//   setTimeout(syncStonesUI, 50);
//   setTimeout(syncStonesUI, 200);
//   setTimeout(syncStonesUI, 500);
// }

// // Catch bfcache restorations, history navigation (e.g. back/forward buttons), and rapid navigations
// window.addEventListener("pageshow", triggerSync);
// window.addEventListener("popstate", triggerSync);

/* Fix: Synchronize Product Variants and UI on browser backward/forward navigation (bfcache) */

// window.addEventListener("pageshow", function () {
//   setTimeout(function () {
//     // 1. Force a change event on all selected form radios to sync `theme.js` ProductVariants
//     document
//       .querySelectorAll('.ProductForm__Option input[type="radio"]:checked')
//       .forEach(function (radio) {
//         radio.dispatchEvent(new Event("change", { bubbles: true }));
//       });
//     // 2. Force a change event on birthstone custom selects to update customizer UI and trigger cascading effects
//     document
//       .querySelectorAll("select.ProductForm__Dropdown, #product-select-stones")
//       .forEach(function (dropdown) {
//         dropdown.dispatchEvent(new Event("change", { bubbles: true }));
//       });
//   }, 100); // 100ms delay ensures customizer initialization scripts execute beforehand
// });

(function () {
  function applyShineToCartItems() {
    document.querySelectorAll(".CartItem__Price[data-hulkapps-ci-price]").forEach(function (el) {
      var handle = el.getAttribute("data-product-handle") || "";
      var key = "shine_discount_" + handle;
      var active = handle && localStorage.getItem(key) === "true";

      if (active) {
        if (el.dataset.shineOriginal) return;
        var raw = parseFloat(el.textContent.replace(/[^0-9.]/g, ""));
        if (!isNaN(raw) && raw > 0) {
          el.dataset.shineOriginal = el.textContent.trim();
          var discounted = Math.round(raw * 0.9);
          el.innerHTML =
            '<span style="color:red;">' + "$" + discounted + "</span>" +
            '&nbsp;<s style="color:#000;">' + el.dataset.shineOriginal + "</s>";
          el.classList.add("Price--highlight");
        }
      } else {
        if (el.dataset.shineOriginal) {
          el.textContent = el.dataset.shineOriginal;
          delete el.dataset.shineOriginal;
          el.classList.remove("Price--highlight");
        }
      }
    });
  }

  // Observe document.body — catches replaceChild anywhere in the cart drawer
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains("Cart") || n.querySelector && n.querySelector(".CartItem__Price")) {
          applyShineToCartItems();
          return;
        }
      }
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    applyShineToCartItems();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
